'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _reactToastify = require('react-toastify');
function Transition(enterClass, exitClass) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [3000];
  var appendPositionToClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return (0, _reactToastify.cssTransition)({
    enter: enterClass,
    exit: exitClass,
    duration: duration.length > 1 ? duration : duration[0],
    appendPosition: appendPositionToClass
  });
}
exports['default'] = Transition;